<div class="flex gap-10 mt-5">
  <div *ngFor="let data of summaryCard" class="relative">
    <div (click)="emit(data.component)" class="shadow-lg min-w-[300px] p-8 flex gap-10 rounded-lg items-center ease-in-out delay-75 transition hover:-translate-y-1 hover:scale-110 hover:cursor-pointer">
      <div *ngFor="let icon of data.data" class="flex flex-col gap-10">
        <div class="flex justify-between">
          <div class="flex gap-4">
            <fa-icon
              [icon]="icon.icon"
              [class]=" ' text-2xl my-auto ' + icon.color"
            ></fa-icon>
            <span class="text-xl font-bold my-auto"> {{ icon.value }} </span>
          </div>
        </div>
        <span class="font-bold"> {{ data.title }} </span>
        <div class="absolute top-4 right-4 flex flex-col gap-2">
          <span *ngFor="let chip of icon.chips" [matTooltip]="chip.title" class="bg-blue-100 flex gap-5 justify-between text-blue-900 text-sm rounded-full px-3 py-1">
            <fa-icon [class]="chip.iconColor" [icon]="chip.icon"></fa-icon>
            {{chip.value}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
